import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.css';

function Top() {
  return (
    <>
      <h2>プロ野球スピリッツA</h2>
      <p>プロ野球スピリッツAのサイトです。</p>
      <p>
        イベントは<Link to="/events">こちら</Link>
        からご確認ください。
      </p>
    </>
  );
}

export default Top;
